import { render } from "./BaseRequiredStar.vue?vue&type=template&id=f338849c"
const script = {}

import exportComponent from "/home/runner/work/megaluzz-admin/megaluzz-admin/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__